export default __webpack_public_path__ + "static/media/coffee hoodie.b37d876b.png";